import { Component, OnInit, Input } from '@angular/core';
import { ControlContainer, FormGroupDirective, FormGroup, FormControl, Validators } from '@angular/forms';
import { PasswordConfirmValidator } from './password-confirm.validator';
import { UserDetail } from '../../models/user-detail';

@Component({
  selector: 'app-user-form',
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.css'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class UserFormComponent implements OnInit {
  private _user: UserDetail;
  @Input() public ff: any;

  constructor(
    public parent: FormGroupDirective
  ) { }

  ngOnInit() {
    this.parent.form.addControl('user', new FormGroup({
      name: new FormControl('', Validators.required),
      surname: new FormControl('', Validators.required),
      email: new FormControl('', [Validators.required, Validators.email]),
      phone: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required),
      confirmPassword: new FormControl('', Validators.required)
    }, PasswordConfirmValidator.passwordMatch));

    if (this._user) {
      this.parent.form.patchValue({
        user: {
          name: this._user.name,
          surname: this._user.surname,
          email: this._user.login.email,
          phone: this._user.phone,
        }
      });
    }

    console.log(this.ff);
  }

  @Input()
  set user(user: UserDetail) {
    this._user = user;
  }

}
